import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface CreateScheduledMessageData {
  message: string
  recipientAccountId?: string
  groupId?: string
  scheduledDate: string // ISO date string
  reason?: string
}

const createScheduledMessage = async (data: CreateScheduledMessageData): Promise<string> => {
  const { data: responseData } = await api.post<string>('/scheduled-message', data)
  return responseData
}

export const useCreateScheduledMessage = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<string, Error, CreateScheduledMessageData>({
    mutationFn: createScheduledMessage,
    onSuccess: async () => {
      showSuccessToast(t('toast.success'), t('toast.scheduledMessageCreated'))
      await queryClient.invalidateQueries({ queryKey: ['scheduled-messages'] })
    },
  })
}

